// extracted by mini-css-extract-plugin
export var circle = "articleCard-module--circle--64433";
export var circleCross = "articleCard-module--circleCross--8e6f2";
export var dateContainerDouble = "articleCard-module--dateContainerDouble--02778";
export var news = "articleCard-module--news--46e73";
export var newsDate = "articleCard-module--newsDate--3f761";
export var newsDouble = "articleCard-module--newsDouble--6fcec";
export var newsImage = "articleCard-module--newsImage--3b2b2";
export var newsImageDouble = "articleCard-module--newsImageDouble--be964";
export var newsInfoContainer = "articleCard-module--newsInfoContainer--62708";
export var newsInfoContainerDouble = "articleCard-module--newsInfoContainerDouble--2d3c4";
export var newsInfos = "articleCard-module--newsInfos--067cb";
export var newsInfosDouble = "articleCard-module--newsInfosDouble--9833c";
export var newsTitle = "articleCard-module--newsTitle--fa71f";
export var newsTitleContainer = "articleCard-module--newsTitleContainer--bc933";
export var newsTitleDouble = "articleCard-module--newsTitleDouble--4ce2b";